import React from 'react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-dark to-pink-50/30" data-id="element-258">
      <div className="max-w-4xl mx-auto text-center" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-pink-100 border border-pink-200 text-brand-accent px-6 py-2 rounded-full mb-8" data-id="element-260">
          <span className="text-xl" data-id="element-261">🏆</span>
          <span className="font-bold tracking-wide text-sm md:text-base" data-id="element-262">
            SISTEMA DE FITNESS PARA MAMÁS – MÉTODO 90D
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-display text-4xl md:text-6xl font-black mb-6 text-gray-900" data-id="element-263">
          6 Tomos + 6 Bonos
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-2xl md:text-3xl text-gray-600 font-medium flex items-center justify-center gap-3" data-id="element-264">
          <span className="text-brand-accent" data-id="element-265">👉</span> Todo tu año resuelto
        </motion.p>
      </div>
    </section>;
}